import { del, get, post, put } from '@/utils/request'

export function createWorkSpaceFolder<T = any>(
  data: { name: string; workspace_id: number; folder_default_classroom_agent: boolean },
) {
  return post<T>({
    url: '/agents-service/workspace-folders/create',
    data,
  })
}

export function updateWorkSpaceFolder<T = any>(
  data: { workspace_folder_id: number; name: string; workspace_id: number; folder_default_classroom_agent?: boolean },
) {
  return put<T>({
    url: `/agents-service/workspace-folders/update/${data.workspace_folder_id}`,
    data,
  })
}

export function deleteWorkSpaceFolder<T = any>(
  data: { workspace_folder_id: number },
) {
  return del<T>({
    url: `/agents-service/workspace-folders/delete/${data.workspace_folder_id}`,
  })
}

export function getListWorkSpaceFolder<T = any>(
  data: { workspace_id: number; page?: number; pageSize?: number; only_user?: boolean },
) {
  return get<T>({
    url: `/agents-service/workspace-folders/list/${data.workspace_id}`,
    data,
  })
}
